import Dialog from "@rio-cloud/rio-uikit/Dialog";
import Spinner from "@rio-cloud/rio-uikit/Spinner";

interface Props {
  show: boolean;
  title: string;
  count: number;
  entityLabel: string;
  isLoading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const DialogDeleteBatch = ({ show, title, count, entityLabel, isLoading = false, onConfirm, onClose }: Props) => (
  <Dialog
    show={show}
    title={<span className="text-medium text-size-16">{title}</span>}
    body={
      <div className="padding-20">
        <p>
          Tem certeza que deseja excluir <strong>{count}</strong> {entityLabel}?
        </p>
        <p className="text-color-danger">Esta ação não pode ser desfeita.</p>
      </div>
    }
    footer={
      <div className="display-flex gap-10 justify-content-end">
        <button className="btn btn-default" onClick={onClose} disabled={isLoading}>
          Cancelar
        </button>
        <button className="btn btn-danger" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? (
            <span className="display-flex align-items-center gap-5">
              <Spinner isInline />
              Excluindo...
            </span>
          ) : (
            "Excluir Selecionados"
          )}
        </button>
      </div>
    }
    onClose={onClose}
    className="exampleDialog"
    showCloseButton
    bsSize="sm"
  />
);

export default DialogDeleteBatch;
